import { Http } from 'sparnord-utils'
import SectionFactory from './section-factory'

export default class Frontpage extends Http.AbstractModel {
  static get _id () {
    return '08f81821-6a75-4b1b-bce9-623ed1994047?depth=3'
  }

  static get endpoint () {
    return `/${Frontpage._id}`
  }

  static async get () {
    let instance = await this.find(Frontpage._id)
    return instance
  }

  static async byUri (uri) {
    try {
      const item = await this.request(`/url?url=/de-smaa-ting/forside${uri}&depth=3`)

      return new this(item)
    } catch (err) {
      return new this({exists: false, properties: {}})
    }
  }

  get sections () {
    return this.item.properties.sektioner.map(section => SectionFactory.make(section)).filter(section => section !== undefined && typeof section.getComponent === 'function')
  }
}



// WEBPACK FOOTER //
// ./src/models/frontpage.js